import React from 'react'
import {
  Form,
  Typography,
  Skeleton,
  Input,
  Button,
  Row,
  Col,
  Select,
  Collapse,
  Divider,
  message
} from 'antd'
import ICharacteristics from '../../../../interfaces/ICharachteristics'
import { BaseFormComponentProps, FormComponent } from '../../../BaseComponent'
import ILanguage from '../../../../interfaces/ILanguage'
import { SearchRequest } from '../../../../services/api/interfaces/ApiRequest'
import IShelter from '../../../../interfaces/IShelter'
import './styles.less'

type ShelterCharacteristicsProps = BaseFormComponentProps & {
  uuid: string
  data: IShelter
  loadShelterSetting: (args: SearchRequest) => Promise<void>

  shelterPetCharacteristicsSettings: any
  characteristics: ICharacteristics
  loadCharacteristics: () => Promise<void>
  dispatchSaveCharacteristicsSetting: (args) => Promise<void>

  languages: ILanguage[]
  loadingLanguages: boolean
  loadLanguages: (args: SearchRequest) => Promise<void>

  loading: boolean
}

export default class Characteristics extends FormComponent<ShelterCharacteristicsProps> {
  state = {
    loaded: false,
    saving: false,
    selectedLanguages: {}
  }

  form: any
  characteristicsGroupColors = {
    medical: '#30A8FF',
    behavior: '#FF8B00',
    environment: '#20A383',
  }
  ALIAS_FIELD_BASE_PATH = ['characteristics_settings', 'alias', 'group', 'key']
  TRANSLATION_FIELD_BASE_PATH = ['characteristics_settings', 'translation', 'group', 'key']

  componentDidMount() {
    const {
      uuid,
      languages,
      characteristics,
      shelterPetCharacteristicsSettings,
      loadLanguages,
      loadShelterSetting,
      loadCharacteristics,
    } = this.props

    this.validateAccessPermissions()
    
    if (!shelterPetCharacteristicsSettings) {
      loadShelterSetting({
        search: {
          organization_shelter: {
            has: {
              uuid
            }
          }
        }
      })
    }

    if (!languages?.length) loadLanguages({ options: {  limit:9999} })

    if (!characteristics?.length) loadCharacteristics()
  }

  getDynamicPath(path: string[], group: string, key: string) {
    const groupindex = path.indexOf('group')
    const keyindex = path.indexOf('key')

    const dynamic = path.slice()
    dynamic[groupindex] = group.toLocaleLowerCase()
    dynamic[keyindex] = key

    return dynamic
  }

  getInitialValues() {
    const { shelterPetCharacteristicsSettings } = this.props
    const groups = {}
    
    shelterPetCharacteristicsSettings?.translation?.forEach((t, index) => {
      const { value } = t
      
      for (const g in value) {
        if (!groups[g]) groups[g] = {}
        for (const c in value[g]) {
          if (!groups[g][c]) groups[g][c] = []
          
          groups[g][c].push({ language: t.language_uuid, value: value[g][c] })
        }
      }
    })
    
    const values = {
      characteristics_settings: {
        alias: shelterPetCharacteristicsSettings,
        translation: groups
      }
    }

    return values
  }

  onLanguageChange(path: string[], name: string[], value: string) {
    const { form } = this

    form.setFields([
      {
        name: [...path, ...name],
        value
      }
    ])

    const itemTranslationKey = path[path.length - 1]
    const currentSelectedLanguages = this.state.selectedLanguages

    if (!currentSelectedLanguages[itemTranslationKey]) currentSelectedLanguages[itemTranslationKey] = []

    const updatedLanguagesList = currentSelectedLanguages[itemTranslationKey][name[0]] = value
    
    this.setState(state => ({
      ...state,
      selectLanguages: {
        ...currentSelectedLanguages,
        [itemTranslationKey]: updatedLanguagesList
      }
    }))
  }

  selectLanguageToAdd(name: number, path: string[]) {
    const { loadingLanguages } = this.props
    const { selectedLanguages } = this.state
    const itemTranslationKey = path[path.length - 1]
    const fieldName: any[] = [name, 'language']
    const defaultLanguage = this.props.data?.country?.default_language?.uuid
    const languages = this.props.languages.filter(l => l.uuid !== defaultLanguage)    

    const value = this.form?.getFieldValue([...path, ...fieldName])
    // Filter by translation field
    if (!selectedLanguages[itemTranslationKey]) selectedLanguages[itemTranslationKey] = []

    const languagesPerField = languages.filter(lang => !selectedLanguages[itemTranslationKey].includes(lang.uuid) || lang.uuid === value)

    return (
      <Select value={value} loading={loadingLanguages} onChange={(value: any) => this.onLanguageChange(path, fieldName, value)} style={{ width: 150 }}>
        {
          languagesPerField.map(lang => (
            <Select.Option key={lang.uuid} value={lang.uuid}>{lang.name} ({lang.abbreviation})</Select.Option>
          ))
        }
      </Select>
    )
  }

  removeLanguageFromList(key, langToRemove: string) {
    if (!!langToRemove) {
      this.setState((state: any) => ({
        ...state,
        selectedLanguages: {
          ...state.selectedLanguages,
          [key]: state.selectedLanguages[key].filter(l => l !== langToRemove)
        }
      }))
    }
  }

  updateGroupLabel(name: string) {
  const updated = name.endsWith('l') ? name : name + 'al'

  return updated
}

  renderGroups() {
    const groups = this.props.characteristics.map((g, index) => {
      const icon = require(`assets/images/icons/${g.name.toLocaleUpperCase()}.svg`)
      const header = (
        <h3 style={{ color: this.characteristicsGroupColors[g.name.toLocaleLowerCase()] }}>
          <img
            src={icon}
            className="characteristic-group-icon"
            alt=""
          />
          {`${this.updateGroupLabel(g.name)} Characteristics`}
        </h3>
      )

      return (
        <Collapse.Panel forceRender className="characteristics-group-header" header={header} key={index}>
          <Row gutter={24}>
            {this.renderCharacteristics(g)}
          </Row>
        </Collapse.Panel>
      )
    })

    const rendered = (
      <Collapse expandIconPosition="right">
        {groups}
      </Collapse>
    )

    return rendered
  }

  renderCharacteristics(group) {
    const rendered = group.characteristics.map((c, index) => {
     // const icon = require(`assets/images/icons/${c.key}.svg`)
      
      return (
        <Col xs={24} key={index}>
          <Typography.Title level={5}>
            <img
              src={`/icons/${c.key}.svg`}
              className="characteristic-icon"
              alt=""
            />
            {c.name}
          </Typography.Title>
          <Typography.Text strong>Description: {c.description}</Typography.Text>
  
          <Form.Item
            label="Custom description"
            name={this.getDynamicPath(this.ALIAS_FIELD_BASE_PATH, group.name, c.key)}
          >
            <Input />
          </Form.Item>
  
          {this.renderTranslations(group, c)}
          
          <Divider />
        </Col>
      )
    })

    return rendered
  }

  renderTranslations(group, characteristic) {
    return (
      <Form.List name={this.getDynamicPath(this.TRANSLATION_FIELD_BASE_PATH, group.name, characteristic.key)}>
        {(fields, { add, remove }) => (
          <>
            {fields?.map((field, index) => {              
              const language = this.form?.getFieldValue([
                ...this.getDynamicPath(this.TRANSLATION_FIELD_BASE_PATH, group.name, characteristic.key),
                field.name,
                'language'
              ])

              return (
                <div key={index} className="characteristic-translation-container">
                  <Form.Item
                    {...field}
                    name={[field.name, 'value']}
                    rules={[{ required: true, message: 'Translation required' }]}
                    style={{ width: '100%', marginBottom: 0 }}
                  >
                    <Input
                      disabled={!language}
                      addonAfter={this.selectLanguageToAdd(field.name, this.getDynamicPath(this.TRANSLATION_FIELD_BASE_PATH, group.name, characteristic.key))}
                    />
                  </Form.Item>

                  <Button type="link" onClick={() => {
                    remove(field.name)

                    this.removeLanguageFromList(characteristic.key, language)
                  }}>
                    Remove this translation
                  </Button>
                </div>
              )
            })}
            {fields?.length < this.props.languages?.length && (
              <Button type="link" onClick={add}>
                Add new description translation
              </Button>
            )}
          </>
        )}
      </Form.List>
    )
  }

  handleSave = values => {
    this.setState({
      saving: true
    }, async () => {
      const translation = {}
      const { translation: translations } = values.characteristics_settings
  
      for (const group in translations) {
        for (const key in translations[group]) {        
          const translationsPerKey = translations[group][key]
          
          translationsPerKey?.forEach(t => {
            if (!translation[t.language]) {
              translation[t.language] = {
                language_uuid: t.language,
                value: {
                  [group]: {
                    [key]: t.value
                  }
                }
              }
            }
  
            if (!translation[t.language].value[group]) {
              translation[t.language].value[group] = {
                [key]: t.value
              }
  
              return
            }
  
            translation[t.language].value[group][key] = t.value
          })
        }
      }
  
      const { uuid: shelter_uuid } = this.props
      const data = {
        shelter_uuid,
        type_key: 'PET_CHARACTERISTICS_ALIAS',
        value: {
          ...values.characteristics_settings.alias,
          translation: Object.values(translation)
        },
        translation: Object.values(translation)
      }
  
      await this.props.dispatchSaveCharacteristicsSetting(data)

      this.setState({ saving: false })
      message.success('Pet characteristics saved!')
    })
  }

  render() {
    const { languages, characteristics } = this.props

    if (!characteristics?.length
      || !languages?.length
    ) return <Skeleton />
    
    const initialValues = this.getInitialValues()

    return (
      <Form
        name="characteristics"
        initialValues={initialValues}
        layout="vertical"
        ref={ref => {
          if (!this.form) {
            this.form = ref
            this.forceUpdate()
          }
        }}
        onFinish={this.handleSave}
      >
        <Typography.Title level={4}>Customize Pet Characteristics Descriptions</Typography.Title>
        <Typography.Text>Allows the shelter to have custom pet characteristics descriptions when displaying this information on public pet profiles.</Typography.Text>
        <Divider />
        {this.renderGroups()}

        <Divider />
        
        <Form.Item>
          <Row gutter={24}>
            <Col span={12} offset={6}>
              <Button
                type="primary"
                htmlType="submit"
                loading={this.state.saving}
                size="large"
                block
                disabled={false}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    )
  }
}
